import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-260da812"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-page ha-page" }
const _hoisted_2 = {
  key: 0,
  class: "ha-signin l-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ha__ttl c-ttl" }, "ログイン", -1))
const _hoisted_4 = { class: "ha-signin__login" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ha-signin__ttl c-card__ttl" }, "集英社IDをお持ちの方", -1))
const _hoisted_6 = { class: "ha-signin__field-container" }
const _hoisted_7 = {
  key: 0,
  class: "ha-errors"
}
const _hoisted_8 = { class: "c-error" }
const _hoisted_9 = { class: "p-fields" }
const _hoisted_10 = { class: "c-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "username"
}, [
  /*#__PURE__*/_createTextVNode("集英社ID"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("（メールアドレス）")
], -1))
const _hoisted_12 = { class: "c-field__body" }
const _hoisted_13 = { class: "c-field__input" }
const _hoisted_14 = { class: "c-field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "password"
}, "パスワード", -1))
const _hoisted_16 = { class: "c-field__body" }
const _hoisted_17 = { class: "c-field__input" }
const _hoisted_18 = ["type", "maxlength"]
const _hoisted_19 = { class: "c-field has-mt" }
const _hoisted_20 = { class: "c-field__auto-signin" }
const _hoisted_21 = {
  class: "c-field__checkbox",
  for: "auto-signin-off"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "自動ログインを無効にする", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ha-signin__note" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "ha-signin__discription" }, "下記のプライバシーガイドライン・各規約に同意のうえ")
], -1))
const _hoisted_24 = { class: "c-field has-submit" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ログイン", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "ha-signin__resetpass has-link" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "パスワードを忘れた方", -1))
const _hoisted_30 = {
  key: 0,
  class: "ha-signin__signup"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ha-signin__ttl c-card__ttl" }, "集英社IDをお持ちでない方", -1))
const _hoisted_32 = { class: "ha-signin__link r-container" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新規会員登録", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LinkageTerms = _resolveComponent("LinkageTerms")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.isDisp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_router_view),
          _createElementVNode("section", {
            class: _normalizeClass(["ha__sec ha-signin__sec", { 'only_login': _ctx.disableSignup }])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("form", {
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.asyncDeterringWrap(_ctx.login, this)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.errorMsgRef)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.errorMsgRef), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("fieldset", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "username",
                            name: "username",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailRef) = $event)),
                            placeholder: "******@**.**.jp",
                            autocomplete: "email",
                            required: ""
                          }, null, 512), [
                            [_vModelText, _ctx.emailRef]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _withDirectives(_createElementVNode("input", {
                            type: _ctx.passwordToggle.fieldType,
                            id: "password",
                            name: "password",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwordRef) = $event)),
                            maxlength: _ctx.PASSWORD_MAX_LENGTH,
                            placeholder: "英字大小文字、数字を含む8文字以上",
                            autocomplete: "current-password",
                            required: ""
                          }, null, 8, _hoisted_18), [
                            [_vModelDynamic, _ctx.passwordRef]
                          ]),
                          _createElementVNode("i", {
                            class: _normalizeClass(["pw-toggle", { 'is-on': _ctx.passwordToggle.isOn }]),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchPasswordFieldType(_ctx.passwordToggle)))
                          }, null, 2)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("label", _hoisted_21, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            name: "auto-signin-off",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.disableAutoLoginRef) = $event)),
                            id: "auto-signin-off"
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.disableAutoLoginRef]
                          ]),
                          _hoisted_22
                        ])
                      ])
                    ]),
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("button", {
                        class: "ha-btn is-submit",
                        disabled: !(_ctx.emailRef&&_ctx.passwordRef) || _ctx.isDeterringRef
                      }, _hoisted_27, 8, _hoisted_25)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_router_link, {
                        to: { name: _ctx.routeNames.RESET_PASSWORD },
                        class: "c-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_29
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createVNode(_component_LinkageTerms, { "initials-calss": 'ha-signin' })
                  ])
                ])
              ], 32)
            ]),
            (!_ctx.disableSignup)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_router_link, {
                      to: { name: _ctx.routeNames.SIGNUP },
                      class: "ha-btn"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_33
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}